import { booleanFieldDefaults, FieldTypes } from '../types/fieldTypes';
import {
  globalOperators,
  nullOperator,
  stringOperators,
} from '../types/operatorTypes';

const source = 'networkBlock';

export const networkBlockDefaultFields = (): FieldTypes[] => [
  {
    label: 'Address Block',
    prop: 'addressBlock',
    operators: [...nullOperator, ...globalOperators, ...stringOperators],
    type: 'text',
    source,
  },
  {
    ...booleanFieldDefaults,
    label: 'Internal',
    prop: 'internal',
    source,
  },
  {
    label: 'Label',
    prop: 'label',
    operators: [...nullOperator, ...globalOperators, ...stringOperators],
    type: 'text',
    source,
  },
  {
    ...booleanFieldDefaults,
    label: 'Suppressed Signals',
    prop: 'suppressesSignals',
    source,
  },
];
